import { React, useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

const GenderInput = forwardRef((props, ref) => {
  const [nowClickedGender, setNowClickedGender] = useState('male');

  const MaleButtonRef = useRef();
  const MaleTextRef = useRef();
  const FemaleButtonRef = useRef();
  const FemaleTextRef = useRef();

  useImperativeHandle(ref, () => ({
		getValue: () => {
			return nowClickedGender;
		},
    setValue: (val) => {
      setNowClickedGender(val);
    }
	}));

  useEffect(() => {
    if (nowClickedGender === 'male') {
      MaleButtonRef.current.style.backgroundColor = `#FF8B48`;
      MaleButtonRef.current.style.border = `1px solid #FF8B48`;
      MaleTextRef.current.style.color = `#FFFFFF`;
      FemaleButtonRef.current.style.backgroundColor = `#FFFFFF`;
      FemaleButtonRef.current.style.border = `1px solid #B2B2B2`;
      FemaleTextRef.current.style.color = `#B2B2B2`;
    }
    else if (nowClickedGender === 'female') {
      MaleButtonRef.current.style.backgroundColor = `#FFFFFF`;
      MaleButtonRef.current.style.border = `1px solid #B2B2B2`;
      MaleTextRef.current.style.color = `#B2B2B2`;
      FemaleButtonRef.current.style.backgroundColor = `#FF8B48`;
      FemaleButtonRef.current.style.border = `1px solid #FF8B48`;
      FemaleTextRef.current.style.color = `#FFFFFF`;
    }
  }, [nowClickedGender])

  return(
    <TopLevelWrapper>
      <Button ref={MaleButtonRef} onClick={() => setNowClickedGender('male')}>
        <ButtonText ref={MaleTextRef}>남성</ButtonText>
      </Button>
      <Button ref={FemaleButtonRef} onClick={() => setNowClickedGender('female')}>
        <ButtonText ref={FemaleTextRef}>여성</ButtonText>
      </Button>
    </TopLevelWrapper>
  )
})

export default GenderInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direcion: row;

  justify-content: center;
  align-items: center;

  margin-top: 8px;

  gap: 8px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 55px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 0 0 0 0;
  
  transition: all 0.3s ease-in-out;
`;